"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchDatasourcesPayloadSchema = exports.patchDatasourcesItem = exports.patchDatasourcesManualSchema = exports.patchDatasourcesSpreadsheetSchema = exports.DatasourceTypes = void 0;
const zod_1 = require("zod");
__exportStar(require("./filter"), exports);
__exportStar(require("./group.by"), exports);
__exportStar(require("./sum.if"), exports);
__exportStar(require("./join"), exports);
__exportStar(require("./procv"), exports);
__exportStar(require("./pull"), exports);
__exportStar(require("./sftp"), exports);
__exportStar(require("./spreadsheet"), exports);
__exportStar(require("./union"), exports);
__exportStar(require("./webhook"), exports);
__exportStar(require("./big.query"), exports);
__exportStar(require("./formula"), exports);
__exportStar(require("./manual"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./s3"), exports);
__exportStar(require("./plan.union"), exports);
__exportStar(require("./unionV2"), exports);
__exportStar(require("./historical"), exports);
__exportStar(require("./payment"), exports);
__exportStar(require("./pullV2"), exports);
var DatasourceTypes;
(function (DatasourceTypes) {
    DatasourceTypes["GOOGLE_SHEETS"] = "google_sheets";
    DatasourceTypes["SPREAD_SHEETS"] = "spread_sheets";
    DatasourceTypes["GROUP_BY"] = "group_by";
    DatasourceTypes["JOIN"] = "join";
    DatasourceTypes["PROCV"] = "procv";
    DatasourceTypes["SFTP"] = "sftp";
    DatasourceTypes["FILTER"] = "filter";
    DatasourceTypes["UNION"] = "union";
    DatasourceTypes["PULL"] = "pull";
    DatasourceTypes["WEBHOOK"] = "webhook";
    DatasourceTypes["BIG_QUERY"] = "big_query";
    DatasourceTypes["PLAN_UNION"] = "plan_union";
    DatasourceTypes["SUM_IF"] = "sum_if";
    DatasourceTypes["MANUAL"] = "manual";
    DatasourceTypes["USER"] = "user";
    DatasourceTypes["S3"] = "s3";
    DatasourceTypes["UNION_V2"] = "union_v2";
    DatasourceTypes["HISTORICAL"] = "historical";
    DatasourceTypes["PAYMENT"] = "payment";
    DatasourceTypes["PULL_V2"] = "pull_v2";
})(DatasourceTypes = exports.DatasourceTypes || (exports.DatasourceTypes = {}));
exports.patchDatasourcesSpreadsheetSchema = zod_1.z.object({
    copy_on_clone: zod_1.z.boolean(),
});
exports.patchDatasourcesManualSchema = zod_1.z.object({
    clean_clones: zod_1.z.boolean(),
});
const sharedConfig = zod_1.z.object({
    datasource_id: zod_1.z.number(),
});
exports.patchDatasourcesItem = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal(DatasourceTypes.SPREAD_SHEETS),
        config: exports.patchDatasourcesSpreadsheetSchema,
    })
        .merge(sharedConfig),
    zod_1.z
        .object({
        type: zod_1.z.literal(DatasourceTypes.MANUAL),
        config: exports.patchDatasourcesManualSchema,
    })
        .merge(sharedConfig),
]);
exports.patchDatasourcesPayloadSchema = zod_1.z.object({
    items: zod_1.z.array(exports.patchDatasourcesItem),
});
